var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { staticClass: "affiliations-process", attrs: { md12: "" } },
    [
      _c(
        "v-layout",
        { attrs: { "fill-height": "", column: "" } },
        [
          _c(
            "div",
            { staticClass: "mb-3" },
            [
              _c("v-layout", { staticClass: "pb-3" }, [
                _c("div", { staticClass: "subtitle--dashboard pl-3" }, [
                  _vm._v("Afiliaciones en proceso")
                ])
              ]),
              _c(
                "v-layout",
                {
                  staticClass: "buttons-table",
                  attrs: {
                    row: "",
                    "justify-space-between": "",
                    "hidden-sm-and-down": ""
                  }
                },
                [
                  _c("search-box", {
                    attrs: { placeholder: "BUSCAR POR NOMBRE O CÓDIGO" },
                    on: { search: _vm.search }
                  }),
                  _c("v-flex"),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        bottom: "",
                        "offset-y": "",
                        left: "",
                        "close-on-content-click": false,
                        "close-on-click": false
                      },
                      model: {
                        value: _vm.menu,
                        callback: function($$v) {
                          _vm.menu = $$v
                        },
                        expression: "menu"
                      }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "v-btn v-btn--light mx-0",
                          attrs: { slot: "activator" },
                          on: { click: _vm.setMenuActivator },
                          slot: "activator"
                        },
                        [_vm._v("Filtros")]
                      ),
                      _c("btn-filters", {
                        attrs: {
                          affiliationsStatus: "En Proceso",
                          conditional: false,
                          tableName: "Process"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "v-btn v-btn--light mr-0",
                      on: { click: _vm.exportTable }
                    },
                    [_vm._v("Exportar")]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "panel-box",
            [
              _c(
                "v-layout",
                { attrs: { "fill-height": "", column: "" } },
                [
                  _c("v-flex", [
                    _c("table", { staticClass: "table mt-3 mb-2" }, [
                      _c("thead", [
                        _c("tr", [
                          _vm.existsAnyNotification
                            ? _c("th", { staticClass: "has-notification-icon" })
                            : _vm._e(),
                          _c(
                            "th",
                            { staticStyle: { padding: "15px !important" } },
                            [_vm._v("Fecha de ingreso")]
                          ),
                          _c("th", [_vm._v("Producto seleccionado")]),
                          _c("th", [_vm._v("RUC")]),
                          _c("th", [_vm._v("Razón Social")]),
                          _vm.$isSupervisor() || _vm.$isBoss() || _vm.$isAdmin()
                            ? _c("th", [_vm._v("Vendedor")])
                            : _vm._e(),
                          _c("th", { staticClass: "visual-responsive" }, [
                            _vm._v("Estado de la solicitud")
                          ])
                        ])
                      ]),
                      _vm.fullTable
                        ? _c(
                            "tbody",
                            [
                              _vm.noContent
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        attrs: {
                                          colspan: _vm.existsAnyNotification
                                            ? 7
                                            : 6
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "No hay información suficiente para mostrar"
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._l(_vm.affiliationsProcess, function(
                                    affiliation,
                                    index
                                  ) {
                                    return _c(
                                      "tr",
                                      {
                                        key: index,
                                        class: {
                                          "has-notification":
                                            affiliation.HasNotification === 1
                                        },
                                        on: {
                                          click: function($event) {
                                            _vm.toDetailProcess(affiliation)
                                          }
                                        }
                                      },
                                      [
                                        _vm.existsAnyNotification
                                          ? _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "has-notification-icon"
                                              },
                                              [
                                                affiliation.HasNotification ===
                                                1
                                                  ? _c("span")
                                                  : _vm._e()
                                              ]
                                            )
                                          : _vm._e(),
                                        _c(
                                          "td",
                                          { staticClass: "table_code" },
                                          [
                                            _vm._v(
                                              _vm._s(affiliation.RegisterDate)
                                            )
                                          ]
                                        ),
                                        _c("td", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(affiliation.SelectProduct)
                                            )
                                          ])
                                        ]),
                                        _c("td", [
                                          _vm._v(_vm._s(affiliation.RUC))
                                        ]),
                                        _c("td", [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(affiliation.BusinessName)
                                            )
                                          ])
                                        ]),
                                        _vm.$isSupervisor() ||
                                        _vm.$isBoss() ||
                                        _vm.$isAdmin()
                                          ? _c("td", [
                                              _vm._v(_vm._s(affiliation.Seller))
                                            ])
                                          : _vm._e(),
                                        _c(
                                          "td",
                                          { staticClass: "visual-responsive" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "hidden-sm-and-up pl-2 pt-2"
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-0" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        affiliation.BusinessName
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-0" },
                                                  [
                                                    _c("strong", [
                                                      _vm._v("RUC")
                                                    ]),
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(affiliation.RUC)
                                                    )
                                                  ]
                                                ),
                                                _c(
                                                  "p",
                                                  { staticClass: "mb-0" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        affiliation.BusinessName
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _c("progress-line", {
                                              attrs: {
                                                value: _vm.progressWidth(
                                                  affiliation.Steps
                                                ),
                                                "on-hold":
                                                  affiliation.OnHold === 1,
                                                "has-notification":
                                                  affiliation.HasNotification ===
                                                  1
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  })
                            ],
                            2
                          )
                        : _c("tbody", [
                            _c("tr", { staticClass: "no__show-data" }, [
                              _c("td", [
                                _vm._v(
                                  "No hay información suficiente para mostrar"
                                )
                              ])
                            ])
                          ]),
                      _c("tfoot", { staticClass: "hidden-sm-and-up" }, [
                        _c("tr", [
                          _c(
                            "td",
                            [
                              _c(
                                "nuxt-link",
                                {
                                  staticClass: "btn-show-all",
                                  attrs: { to: "dashboard/process" }
                                },
                                [_vm._v("Ver todas")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ]),
                  _vm.fullTable
                    ? _c("pagination-box", {
                        attrs: { "total-pages": _vm.totalItems },
                        on: { input: _vm.pagination }
                      })
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dbbd0e60", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dbbd0e60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/affiliations-process.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-dbbd0e60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/affiliations-process.vue
// module chunks = 0 5